import { render } from "./VDevider.vue?vue&type=template&id=1bf2f8dd"
const script = {}

import exportComponent from "/var/www/html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__